<template lang="pug">
    div#app.contFluid
        router-view

        form-word(:toggle="popup.addWord" @close="onClose")
        feedback(:toggle="popup.feedback" @close="onClose")

        div.cf_clearfix
        footer.row.footer
            div.container
                div.cell.site © 2019 STMEGI Media Group
                div.cell.app
                    div.title Наши приложения
                    div.wrapper
                        a.apple(href="https://apps.apple.com/ru/developer/stmegi/id1367510158?l=ru" target="_blank" :style="{'background-image': 'url(' + require('@/assets/app.png') + ')'}")
                        a.google(href="https://play.google.com/store/apps/developer?id=STMEGI" target="_blank" :style="{'background-image': 'url(' + require('@/assets/app.png') + ')'}")
                ul.cell.menu
                    li(@click="popup.feedback = !popup.feedback") Обратная связь
                    li(@click="popup.addWord = !popup.addWord") Добавить слово
            //container
        //footer
    //contFluid
</template>

<script>
    import formWord from './components/FormWord';
    import feedback from './components/Feedback';
    export default {
        name: "App",
        data() {
            return {
                popup: {
                    addWord: false,
                    feedback: false
                }
            }
        },
        methods: {
            onClose(data, popup) {
                this.popup[popup] = data
            },
        },
        components: {
            formWord,
            feedback
        }
    }
</script>
